import { ResetPasswordForm } from "@/components";
import { LocalStorageUtils } from "@/utils";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

export const Route = createFileRoute("/auth/reset-password")({
  component: ResetPasswordPage,
});

function ResetPasswordPage() {
  const [savedEmail, setSavedEmail] = useState<string | null>(null);

  useEffect(() => {
    const lastEmail = LocalStorageUtils.LocalStorageUtils.getLastLoginEmail();
    setSavedEmail(lastEmail);
  }, []);

  return (
    <div className="bg-white flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        <ResetPasswordForm defaultEmail={savedEmail || undefined} />
      </div>
    </div>
  );
}
